import {useQuery} from "@tanstack/react-query"

import axios from "config/axios"
import {setLocalStorageValue} from "config/helper"
import {ReactQueryKeys} from "config/constant"
import {useApiDefaults} from "./useApiDefaults"
import { refetchOnWindowFocus } from "config/reactQuery";

export function useGetCustomerDetails(enabled = true) {
  const apiDefaults = useApiDefaults()

  async function getData() {
    if (!enabled) {
      return {}
    }
    
    const response = await axios.post("/AogGetCustomer", apiDefaults)
    const data = response.data.data
    setLocalStorageValue("first-name", data.first_name)
    setLocalStorageValue("last-name", data.last_name)
    setLocalStorageValue("mobile-number", data.mobile_number)

    return data
  }

  const {
    data = {},
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: [ReactQueryKeys.CUSTOMER_DETAILS, apiDefaults],
    queryFn: getData,
    refetchOnWindowFocus,
  })

  return {
    data,
    isLoading,
    error,
    refetch,
  }
}
